'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'compass';
var width = 512;
var height = 512;
var aliases = [129517];
var unicode = 'f14e';
var svgPathData = 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm95.1-381.5L204.6 179.4c-11.9 4-21.3 13.4-25.3 25.3L130.5 351.1c-6.3 18.8 11.6 36.6 30.4 30.4l146.5-48.8c11.9-4 21.3-13.4 25.3-25.3l48.8-146.5c6.3-18.8-11.6-36.6-30.4-30.4zm15.2 25.3L317.5 302.3c-2.4 7.2-8 12.8-15.2 15.2L155.8 366.3c-6.3 2.1-12.2-3.9-10.1-10.1l48.8-146.5c2.4-7.2 8-12.8 15.2-15.2l146.5-48.8c6.3-2.1 12.2 3.9 10.1 10.1zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompass = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;